module.exports = __webpack_public_path__ + "audio-e9f58b97c2f0.m4a";